import { openBlock as e, createElementBlock as a, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, t = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M16.36 1.464a3 3 0 0 0-4.243 0L5.753 7.828a1 1 0 0 0 0 1.414l-1.415 1.415a1 1 0 0 0 0 1.414l2.122 2.121a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 1.414 0l4.99-4.99.24.212a6.38 6.38 0 0 1-1.375 10.502 2.943 2.943 0 0 0-5.176.227 6.391 6.391 0 0 1-2.301-1.555h1.016a.75.75 0 0 0 0-1.5H3.86a.75.75 0 0 0 0 1.5h1.305a7.903 7.903 0 0 0 3.93 3.05c.024.354.112.692.252 1H1.652a.75.75 0 0 0 0 1.5h20.47a.75.75 0 0 0 0-1.5h-7.408a2.933 2.933 0 0 0 .26-1.258A7.882 7.882 0 0 0 17 6.942l-.243-.219.31-.309a3 3 0 0 0 0-4.242l-.708-.708Zm-.354 1.768-.707-.707a1.5 1.5 0 0 0-2.122 0l-6.01 6.01 2.828 2.829 6.01-6.01a1.5 1.5 0 0 0 0-2.122ZM6.46 10.657l-.708.707 1.415 1.414.707-.707-1.414-1.414Zm4.787 10.568a1.442 1.442 0 0 1 .784-2.656 1.443 1.443 0 0 1 .784 2.656h-1.568Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  t
];
function n(r, d) {
  return e(), a("svg", o, [...c]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
